import { useRef, useState } from 'react';
import { SecondaryText } from '@monorepo/base/src/components/buttons/buttons';
import { Menu } from '@monorepo/base/src/components/menu/menu';
import { Nav, NavItem } from '@monorepo/base/src/components/nav/nav';
import { IconFonts } from '@monorepo/base/src/components/icon/icon';
import { getTheme } from '@monorepo/tools/src/lib/get-config';
import { Divider } from '@monorepo/base/src/components/divider/divider';
import styles from './filter-dropdown.module.scss';

const theme = getTheme();

type FilterOption = {
	value: string;
	label: string;
};

type FilterDropdownProps = {
	label: string;
	icon: string;
	options: FilterOption[];
	selectedValue: string;
	onSelect: (value: string) => void;
	onReset?: () => void;
};

export function FilterDropdown({ label, icon, options, selectedValue, onSelect, onReset }: FilterDropdownProps) {
	const [isMenuOpen, setMenuOpen] = useState<boolean>(false);
	const menuRef = useRef<HTMLDivElement>(null);

	const currentLabel = options.find(option => option.value === selectedValue)?.label || '';

	const onMenuToggle = () => {
		setMenuOpen(!isMenuOpen);
	};

	const onOptionClick = (value: string) => {
		setMenuOpen(false);
		onSelect(value);
	};

	const onResetClick = () => {
		setMenuOpen(false);
		if (onReset) {
			onReset();
		}
	};

	return (
		<div className={styles.filterItem} ref={menuRef}>
			<SecondaryText
				className={`${styles.filterBtn} ${selectedValue ? styles.active : styles.notActive}`}
				icon={icon}
				font={IconFonts.Outlined}
				iconColor={theme.actionLinerActionIconsColor}
				iconSize={'18px'}
				onClick={onMenuToggle}>
				<div className={styles.filterText}>{label}</div>
				{currentLabel && currentLabel !== '' ? <div className={styles.currentFilterTitle}>{currentLabel}</div> : null}
			</SecondaryText>
			<Menu isOpen={isMenuOpen} className={styles.menuBelowLeft} onClose={() => setMenuOpen(false)}>
				<Nav list>
					{options.map(option => (
						<NavItem
							key={option.value}
							className={`${selectedValue === option.value ? styles.highlight : ''}`}
							onNavItem={() => onOptionClick(option.value)}>
							<div className={styles.menuItem}>
								<div>{option.label}</div>
							</div>
						</NavItem>
					))}
				</Nav>
				<Divider />
				<button className={styles.resetButton} onClick={onResetClick}>
					Reset
				</button>
			</Menu>
		</div>
	);
}
